/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import StatusContainer from "../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { useDispatch } from "react-redux";
import CommonToast from "../../_utils/CommonToast";

const FieldForceTransactionMultiApprovalDeclined = () => {
  const [declinedPageData, setdeclinedPageData] = useState([]);
  const [declinedPageID, setdeclinedPageID] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedFieldForceTxnData"),
    );

    if (storedSelectedApproval) {
      setdeclinedPageData(
        storedSelectedApproval?.selectedSendTransactions || [],
      );
      setdeclinedPageID(storedSelectedApproval?.selectedTransactions || []);
    } else {
      setdeclinedPageData([]);
      setdeclinedPageID([]);
    }
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const buttonRows = [
    [
      {
        btnText: "Go to approval",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.GO_TO_APPROVAL,
        imgColor: "var(--positive-bg)",
        handleFunction: () => {
          navigate(
            "/field_force_transaction_dashboard/field_force_transaction_multi_approval",
          );
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => {
          navigate("/field_force_transaction_dashboard");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const TransactionList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions?.map((account, i) => (
        <InfoCard
          key={account?.txn_id || i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${account?.txn_id}`,
            )
          }
          rows={[
            {
              leftTitle: account?.field_force_account_name,
              leftSubTitle: account?.rejection_reason
                ? `Reason: ${account.rejection_reason}`
                : "Account name",

              rightTitle: (
                <>
                  INR <FormatAmount price={account?.amount} />
                </>
              ),
              rightSubTitle: "Amount",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
              hasRight: true,

              rightIcon: true,
              rightText: true,
              onClick: () =>
                navigate(
                  `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${account?.txn_id}`,
                ),
            },
          ]}
        />
      ))}
    </div>
  );

  return (
    <StatusContainer
      status="success"
      buttonRows={buttonRows}
      title={
        declinedPageID?.length
          ? "Transactions rejected successfully."
          : "Processing rejections..."
      }
    >
      <TabsWeapperSection
        title={`Rejected transactions  - ${
          declinedPageID?.length || declinedPageData?.length
        }`}
      >
        <TransactionList transactions={declinedPageData} />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default FieldForceTransactionMultiApprovalDeclined;
